export default __webpack_public_path__ + "static/media/shinemji.ea83cb2a.png";